import React, {useEffect, useState} from "react";
import {fetchDocument} from "../../Service/restapi/sharedContractService";
import PositionList from "./PositionList";


const DocumentPositionList = ({formSubmission, resourceId, documentId, values, handleChange, patchSubmissionValue, document}) => {
    const [currentDocument, setCurrentDocument] = useState(document);
    const [positions, setPositions] = useState(undefined);
    const [isSummable, setSummable] = useState(undefined);
    const [taxType, setTaxType] = useState(undefined);

    useEffect(() => {
        setCurrentDocument(document);
    }, [document]);

    useEffect(() => {
        fetchDocument(documentId).then(resp => {
            if (resp.ok) {
                resp.json().then(document => {
                    setCurrentDocument(document);
                    setPositions(document.positions);
                    setSummable(document.summable);
                    setTaxType(document.taxType);
                })
            } else {
                console.error("could not fetch positions of document " + documentId);
            }
        }).catch(error => {
            console.error("could not fetch positions of document " + documentId);
            console.error({error});
        });
    }, [documentId]);

    const handlePositionChange = (updatedPosition) => {
        setPositions(positions => positions.map(position => position.id === updatedPosition.id ? updatedPosition : position));
    };

    const displayedDocument = currentDocument || document;

    return (
        <PositionList
            resourceId={resourceId}
            document={displayedDocument}
            positions={positions}
            positionGroups={displayedDocument.positionGroups}
            isSummable={isSummable}
            taxType={taxType}
            formSubmission={formSubmission}
            values={values}
            handleChange={handleChange}
            patchSubmissionValue={patchSubmissionValue}
            onPositionChange={handlePositionChange}
        />
    );
};

export default DocumentPositionList;
